import classNames from 'classnames';

import { Phone } from '~components/AllianceCallService/AllianceCallService';
import { useAppSelector } from '~hooks/useRedux';

const SepDisclaimer = ({
    maincopy,
    telephoniccopy,
    backgroundsurface = 'bg-surface-light',
}: {
    maincopy: string;
    telephoniccopy: string;
    backgroundsurface: SupportedBackgroundColor;
}) => {
    const throttle = useAppSelector((state) => state.global.throttle);

    return (
        <div className={classNames(backgroundsurface)}>
            <div
                className={classNames(
                    'max-w-screen-lg mx-auto text-center font-poppins text-16 md:text-18 leading-24 md:leading-28 text-primary-dark px-4 pt-6 md:pt-10'
                )}
                id="sepDisclaimerAnchor"
            >
                {maincopy}{' '}
                <span className={classNames(throttle && throttle !== 'GREEN' && 'hidden')}>
                    {telephoniccopy} <Phone classname="" fromComponentName="SEP Disclaimer" /> TTY
                    711
                </span>
            </div>
        </div>
    );
};

export default SepDisclaimer;
